import { FileDocIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { Card } from "@vega-core/components/shadcn/card";
import { Tag } from "@vega-core/components/Tag/Tag";
import { m } from "@vega-core/paraglide/messages";

import { SECTION_IDS } from "../constants/overviewConstants";

type DocumentItem = {
  title: string;
  filename: string;
  onViewDocument?: () => void;
  onDownloadDocument: () => void;
  dataTestId: string;
};

type DocumentsSectionProps = {
  documents: DocumentItem[];
};

export const DocumentsSection = ({ documents }: DocumentsSectionProps) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4" id={SECTION_IDS.DOCUMENTS}>
      <h3 className="text-text/primary body-large-semibold">
        {m.documents_title()}
      </h3>
      <div className="space-y-4">
        {documents.map((doc) => (
          <Card className="p-3 lg:p-4" key={doc.dataTestId}>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
              <div
                className="flex items-center gap-6 min-w-0 flex-1 w-full sm:w-auto"
                title={doc.filename}
              >
                <FileDocIcon className="flex-shrink-0" />
                <span className="body-base-regular text-text/primary break-all overflow-hidden grow">
                  {doc.filename}
                </span>
                <Tag variant="Default">{doc.title}</Tag>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full sm:w-auto">
                <ThemedButton
                  className="flex-1 sm:flex-initial w-full sm:w-auto"
                  dataTestId={`${doc.dataTestId}-download`}
                  onClick={doc.onDownloadDocument}
                  variant="secondary"
                >
                  {m.btn_download()}
                </ThemedButton>
                {doc.onViewDocument ? (
                  <ThemedButton
                    className="flex-1 sm:flex-initial w-full sm:w-auto"
                    dataTestId={doc.dataTestId}
                    onClick={doc.onViewDocument}
                    variant="primary"
                  >
                    {m.coInvestments_dealReview_viewDocument()}
                  </ThemedButton>
                ) : null}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
